export function getSelectedFromScore(
  score: ClientAssessmentScore,
  quiz: QuizDetails,
): number[] {
  const answer = score[quiz.uuid];
  if (!answer) return [];
  return answer.selected;
}

export function areAllCorrectSelected(
  selected: number[],
  correct: number[],
): boolean {
  return correct.every((c) => selected.includes(c));
}

export function wasIncorrectSelected(
  selected: number[],
  correct: number[],
): boolean {
  return selected.some((s) => !correct.includes(s));
}

export function getIsCompleted(selected: number[], correct: number[]): boolean {
  return (
    selected.length > 0 &&
    (areAllCorrectSelected(selected, correct) ||
      wasIncorrectSelected(selected, correct))
  );
}

export function getOptionByIndexFromQuiz(
  quiz: QuizDetails,
  index: number,
): QuizOption | undefined {
  return quiz.options[index];
}

/**
 * Komentarz bywa formalnie obecny, ale pusty: przy odpowiedziach, których omówienie sprowadzało
 * się do samego werdyktu ("To nie jest prawidłowa odpowiedź."), treść jest wycinana po stronie
 * backendu. Zostaje `[]` albo akapit z samą spacją — i jedno, i drugie traktujemy jak brak.
 */
export function hasCommentContent(
  blocks: ContentBlock[] | undefined | null,
): boolean {
  return (blocks ?? []).some(
    (block) =>
      block.type !== "paragraph" ||
      (block.data?.text ?? "").replace(/<[^>]*>|&nbsp;|\s/g, "") !== "",
  );
}
